export const groupSubtopics = (topics) => topics.reduce((accumulator, topic) => {
  const topicGroup = accumulator.find(({ id }) => id === topic.id)
  if (topicGroup) {
    topicGroup.subTopics.push(topic)
  } else {
    accumulator.push({
      id: topic.id,
      topic: topic.topic,
      subTopics: [topic]
    })
  }
  return accumulator
}, [])